import(/* webpackMode: "eager" */ "/dashphil/app/globals.css");
import(/* webpackMode: "eager" */ "/dashphil/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/dashphil/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/dashphil/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/dashphil/components/ui/tooltip.tsx")